import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useTRPC } from '../../lib/api';

/**
 * Os grupos com uma rajada de saídas em aberto (`GROUP_EXIT_BURST`, ADR-0019) — o selo
 * "evasão anormal" da lista de grupos. Quem decide é o guardião no servidor; aqui só se
 * cruza o incidente aberto com a linha. Sem permissão de ler incidentes (ou se a leitura
 * falhar), simplesmente não há selo: a lista de grupos não depende disto.
 */
export function useGruposComEvasaoAnormal(workspaceId: string): ReadonlySet<string> {
  const trpc = useTRPC();
  const q = useQuery({
    ...trpc.incident.list.queryOptions({ workspaceId, status: 'OPEN', limit: 50 }),
    retry: false,
  });
  return useMemo(() => {
    const ids = new Set<string>();
    for (const inc of q.data?.incidents ?? []) {
      if (inc.type === 'GROUP_EXIT_BURST' && inc.entityId) ids.add(inc.entityId);
    }
    return ids;
  }, [q.data]);
}
